import { render, staticRenderFns } from "./lgactivity.vue?vue&type=template&id=04c32406&"
import script from "./lgactivity.vue?vue&type=script&lang=js&"
export * from "./lgactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports